<template>
  <a-modal
    :open="visible"
    :footer="null"
    :closable="false"
    :mask-closable="false"
    centered
    width="460px"
  >
    <div class="prompt-content">
      <div class="prompt-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 640 640"
          fill="#faad14"
        >
          <path
            d="M240 160L240 224L400 224L400 160C400 115.8 364.2 80 320 80C275.8 80 240 115.8 240 160zM192 224L192 160C192 89.3 249.3 32 320 32C390.7 32 448 89.3 448 160L448 224C483.3 224 512 252.7 512 288L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 288C128 252.7 156.7 224 192 224zM400 272L240 272L240 272L192 272L192 272C183.2 272 176 279.2 176 288L176 512C176 520.8 183.2 528 192 528L448 528C456.8 528 464 520.8 464 512L464 288C464 279.2 456.8 272 448 272L448 272L400 272L400 272zM280 300C291 300 300 309 300 320L300 340L340 340L340 320C340 309 349 300 360 300C371 300 380 309 380 320L380 340L400 340C411 340 420 349 420 360C420 371 411 380 400 380L380 380L380 420L400 420C411 420 420 429 420 440C420 451 411 460 400 460L380 460L380 480C380 491 371 500 360 500C349 500 340 491 340 480L340 460L300 460L300 480C300 491 291 500 280 500C269 500 260 491 260 480L260 460L240 460C229 460 220 451 220 440C220 429 229 420 240 420L260 420L260 380L240 380C229 380 220 371 220 360C220 349 229 340 240 340L260 340L260 320C260 309 269 300 280 300zM300 380L300 420L340 420L340 380L300 380z"
          />
        </svg>
      </div>
      <h3 class="prompt-title">2단계 인증 설정 안내</h3>
      <p class="prompt-message">
        고객사의 민감 정보를 다루는 페이지에서는 2단계 인증을 적극 권장하고
        있습니다.<br />2단계 인증을 설정하시겠어요?
      </p>
      <div class="prompt-buttons">
        <a-button type="primary" size="large" block @click="handleGoSetup">
          설정하러가기
        </a-button>
        <a-button size="large" block @click="handleDismiss">
          다음에 하기
          <span class="dismiss-sub">(오늘 하루동안 뜨지 않게 하기)</span>
        </a-button>
        <a-button type="link" block @click="handleSnooze">
          일주일 뒤에 다시 알리기
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

const SNOOZE_KEY = 'twoFactorPromptSnoozeUntil';
const DISMISS_KEY = 'twoFactorPromptDismissedDate';
const SNOOZE_DAYS = 7;

function getTodayDateString(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    '0'
  )}-${String(d.getDate()).padStart(2, '0')}`;
}

export default defineComponent({
  name: 'TwoFactorPromptModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['go-setup', 'dismiss', 'snooze'],
  setup(props, { emit }) {
    const handleGoSetup = () => {
      emit('go-setup');
    };

    const handleDismiss = () => {
      localStorage.setItem(DISMISS_KEY, getTodayDateString());
      emit('dismiss');
    };

    const handleSnooze = () => {
      const snoozeUntil = Date.now() + SNOOZE_DAYS * 24 * 60 * 60 * 1000;
      localStorage.setItem(SNOOZE_KEY, String(snoozeUntil));
      emit('snooze');
    };

    return {
      handleGoSetup,
      handleDismiss,
      handleSnooze,
    };
  },
});

export function shouldShowTwoFactorPrompt(): boolean {
  const dismissedDate = localStorage.getItem('twoFactorPromptDismissedDate');
  if (dismissedDate === getTodayDateString()) return false;

  const snoozeUntil = localStorage.getItem('twoFactorPromptSnoozeUntil');
  if (snoozeUntil && Date.now() < Number(snoozeUntil)) return false;

  return true;
}
</script>

<style scoped>
.prompt-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 8px 8px;
  text-align: center;
}

.prompt-icon {
  margin-bottom: 16px;
}

.prompt-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 12px;
}

.prompt-message {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 28px;
}

.prompt-buttons {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.prompt-buttons :deep(.ant-btn-primary) {
  border-radius: 8px;
  font-weight: 600;
  height: 44px;
}

.prompt-buttons :deep(.ant-btn-default) {
  border-radius: 8px;
  height: 44px;
}

.dismiss-sub {
  font-size: 12px;
  color: #999;
  margin-left: 4px;
  font-weight: 400;
}

.prompt-buttons :deep(.ant-btn-link) {
  color: #999;
  font-size: 13px;
}
</style>
